import { render, staticRenderFns } from "./BrandsModal.vue?vue&type=template&id=72420282&scoped=true"
import script from "./BrandsModal.vue?vue&type=script&lang=js"
export * from "./BrandsModal.vue?vue&type=script&lang=js"
import style0 from "./BrandsModal.vue?vue&type=style&index=0&id=72420282&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72420282",
  null
  
)

export default component.exports